import { Address } from "../../model/Address";

const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
const GOOGLE_URL = "https://maps.googleapis.com/maps/api/geocode/json?address=";

export const GeocodeAddress = async (addressObject: Address): Promise<{ latitude: number; longitude: number }> => {
    const { address, city, province, country } = addressObject;

    const url =
        GOOGLE_URL +
        (address ? encodeURIComponent(`${address},`) : "") +
        (city ? encodeURIComponent(`${city}, `) : "") +
        (province ? encodeURIComponent(`${province.name}, `) : "") +
        (country ? encodeURIComponent(`${country.name}, `) : "") +
        `&key=${GOOGLE_KEY}`;

    const response = await fetch(url);
    const responseJson = await response.json();
    if (
        !responseJson ||
        !responseJson.results ||
        responseJson.results.length <= 0 ||
        !responseJson.results[0].geometry ||
        !responseJson.results[0].geometry.location
    ) {
        throw new Error("Could not parse result from server.");
    }

    const location = responseJson.results[0].geometry.location;
    return { latitude: location.lat, longitude: location.lng };
};



// WEBPACK FOOTER //
// ./src/common/Methods/Geocoder.ts